<template>
  <NavBarSettings>
    <!-- Back to the workspace — studio-design `tv-nav-back`: chevron (14px,
         surface-500) + the workspace name, padding 8px, hover surface-100. -->
    <template #top>
      <NuxtLink
        v-tooltip.right="navCollapsed ? workspaceName : undefined"
        class="group flex w-full items-center gap-1.5 rounded-lg p-2 text-surface-700 transition-colors hover:bg-surface-100 hover:text-surface-900"
        :class="navCollapsed ? 'justify-center' : ''"
        :to="{
          name: 'organizationSlug-workspaceId',
          params: { organizationSlug, workspaceId },
        }"
      >
        <AppIcon
          icon="fa-solid fa-chevron-left"
          class="text-sm text-surface-500"
        />
        <span
          v-if="!navCollapsed"
          class="truncate text-sm font-medium"
          >{{ workspaceName }}</span
        >
      </NuxtLink>
    </template>

    <!-- Workspace-settings navigation — one route per section (studio-design
         `workspace-settings` sidebar variant). -->
    <template #nav-items>
      <div class="flex flex-col gap-1.5">
        <NavBarSettingsItem
          v-for="item in sections"
          :key="item.name"
          :label="item.label"
          :icon="item.icon"
          :to="{ name: item.name, params: { organizationSlug, workspaceId } }"
        />
      </div>
    </template>

    <template #footer>
      <NavBarAccountButton />
    </template>
  </NavBarSettings>
</template>

<script setup lang="ts">
import { useWorkspaceStore } from '~/stores/workspace'
import { useLayoutPreferencesStore } from '~/stores/layoutPreferences'

const route = useRoute()
const workspaceStore = useWorkspaceStore()

// Always the flat variant → collapses to a rail when the layout is minimized.
// Computed locally because NavBar (the provider) is a child of this component.
const layoutStore = useLayoutPreferencesStore()
const navCollapsed = computed(() => layoutStore.currentLayout === 'float')

const organizationSlug = computed(() => {
  const param = route.params.organizationSlug
  return typeof param === 'string' ? param : ''
})
const workspaceId = computed(() => {
  const param = route.params.workspaceId
  return typeof param === 'string' ? param : ''
})

const workspaceName = computed(
  () => workspaceStore.currentWorkspace?.title ?? 'Workspace',
)

const sections = [
  {
    name: 'organizationSlug-workspaceId-settings-summary',
    label: 'Summary',
    icon: 'fa-regular fa-chart-tree-map',
  },
  {
    name: 'organizationSlug-workspaceId-settings-general',
    label: 'General',
    icon: 'fa-regular fa-gear',
  },
  {
    name: 'organizationSlug-workspaceId-settings-users',
    label: 'Users',
    icon: 'fa-regular fa-user-group',
  },
  {
    name: 'organizationSlug-workspaceId-settings-integrations',
    label: 'Integrations',
    icon: 'fa-regular fa-link',
  },
]
</script>
